import {ChangeDetectorRef, Component, Inject, Input, OnInit} from "@angular/core";
import {ApiCommunicationService} from "../../../shared/model/services/api-communication/api-communication.service";
import {AuthorizationError} from "../../../shared/model/exception/AuthorizationError";
import {ModalServiceProxy} from "../../../commons/services/modal/modal.service.proxy";
import {Comment} from "../../../shared/model/data/social/Comment";
import {CommentType} from "../../../shared/model/data/enums/CommentType";
import {Content} from "../../../shared/model/content/Content";
import {UserSessionService} from "../../../auth/session/services/user-session/user-session.service";

@Component({
	selector: "app-blogpost-comments",
	templateUrl: "./blogpost-comments.component.html",
	styleUrls: ["./blogpost-comments.component.scss"]
})
export class BlogPostCommentsComponent implements OnInit {

	@Input("item")
	public item: Content;

	constructor(@Inject(ApiCommunicationService) private api: ApiCommunicationService,
				@Inject(ModalServiceProxy) private modalServiceProxy: ModalServiceProxy,
				@Inject(UserSessionService) private userSessionService: UserSessionService,
				@Inject(ChangeDetectorRef) private changeDetector: ChangeDetectorRef) {
	}

	ngOnInit() {
	}

	public sendComment(event: KeyboardEvent): void {

		// the source element of the event
		const inputElement: HTMLInputElement = (<HTMLInputElement>event.srcElement);

		// request to send
		const requestData = new Comment();
		requestData.message = inputElement.value;
		requestData.type = CommentType.MICROBLOGPOST;
		requestData.content = this.item._id;

		try {
			this.api.comment().comment(requestData)
				.subscribe((res) => {
					// add comment from server to the comments
					requestData.user = this.userSessionService.userDataValue;
					requestData._id = res._id;
					this.item.comments.push(requestData);

					// reset field
					inputElement.value = "";

					// let the change detector know that changes happened
					this.changeDetector.markForCheck();
				});
		} catch (e) {
			// check if user is logged in, show login modal if not
			if (e instanceof AuthorizationError) {
				this.modalServiceProxy.get().showLoginModal();
			}
		}
	}

}
